

import Vue from "vue";
import {
  Contact,
  contactApi,
  ContactSearchRow, createContactInfos,
  EmailAddress,
  PhoneNumber,
  PhoneNumberType,
} from "@/api/contacts";
import {Dossier} from "@/api/flame";
import ContactPhonenumber from "@/views/contacts/ContactPhonenumber.vue";
import ContactEmail from "@/views/contacts/ContactEmail.vue";
import {ContactRelationResult,} from "@/api/contactRelation";
import {findConfirmDialogRef} from "@/utils/RefUtils";

export interface AvisFormInputDTO {
    dossier: Dossier | null;
    contact: Contact;
    resellerContacts: ContactRelationResult[];
}

function addEmailAddressesFromContact(
    contact: Contact | ContactSearchRow,
    emailAddresses: { value: string; text: string }[]
) {
    if (contact  && contact.emailAddresses) {
        contact.emailAddresses.forEach((email) => {
            emailAddresses.push({
                value: email.id ?? "",
                text:
                    createContactInfos(email.sharedByContactPersonRef ?? null, contact) + " - " +
                    (email.address ? email.address : "keine E-Mail-Adresse gesetzt"),
            });
        });
    }
}

function addPhoneNumbersFromContact(
    contact: Contact | ContactSearchRow,
    phoneNumbers: { value: string; text: string }[]
) {
    if (contact && contact.phoneNumbers) {
        contact.phoneNumbers.forEach((phoneNumber) => {
            phoneNumbers.push({
                value: phoneNumber.id ?? "",
                text:
                    createContactInfos(phoneNumber.sharedByContactPersonRef ?? null, contact) + " - " +
                    (phoneNumber.number ? phoneNumber.number : "keine Rufnummer gesetzt"),
            });
        });
    }
}


export default Vue.extend({
    components: {
        ContactPhonenumber,
        ContactEmail
    },
    props: {
        avisFormInput: {
            type: Object as () => AvisFormInputDTO,
            required: true,
        },
        isWorking: {
            type: Boolean,
        },
        readonly: {
            type: Boolean,
        },
    },
    data() {
        return {
            avisPhoneNumberRef: this.avisFormInput.dossier?.avisPhoneNumberRef,
            avisEmailRef: this.avisFormInput.dossier?.avisEmailRef,
            avisPhoneNumber: null as PhoneNumber | null,
            avisEmail: null as EmailAddress | null,
            newAvisPhoneNumberAddressContactRef: null as string | null,
            newAvisEmailAddressContactRef: null as string | null,
            avisText: null as string | null,
        }
    },
    computed: {
        phoneNumbers(): { value: string; text: string }[] {
            const phoneNumbers: { value: string; text: string }[] = [];
            if (this.avisFormInput.resellerContacts && this.avisFormInput.resellerContacts.length > 0) {
                this.avisFormInput.resellerContacts.forEach(
                    (resellerContact: ContactRelationResult) => {
                        addPhoneNumbersFromContact(resellerContact.withContact,  phoneNumbers);
                    });
                if (this.avisFormInput.contact && this.avisFormInput.contact.phoneNumbers) {
                    addPhoneNumbersFromContact(this.avisFormInput.contact,  phoneNumbers);
                }
            } else {
                if (this.avisFormInput.contact && this.avisFormInput.contact.phoneNumbers) {
                    addPhoneNumbersFromContact(this.avisFormInput.contact,  phoneNumbers);
                }
            }
            return phoneNumbers;
        },
        emailAddresses(): { value: string; text: string }[] {
            const emailAddresses: { value: string; text: string }[] = [];
            if (this.avisFormInput.resellerContacts && this.avisFormInput.resellerContacts.length > 0) {
                this.avisFormInput.resellerContacts.forEach(
                    (resellerContact: ContactRelationResult) => {
                        addEmailAddressesFromContact(
                            resellerContact.withContact,
                            emailAddresses
                        );
                    }
                );
                if (this.avisFormInput.contact && this.avisFormInput.contact.emailAddresses) {
                    addEmailAddressesFromContact(this.avisFormInput.contact,  emailAddresses);
                }
            } else {
                addEmailAddressesFromContact(this.avisFormInput.contact,  emailAddresses);
            }
            return emailAddresses;
        },
    },
    watch: {
        avisFormInput: {
            async handler() {
                this.resetData();
                if (this.avisFormInput.dossier?.avisPhoneNumberRef) {
                  this.avisPhoneNumber = await contactApi.getPhoneNumberById(
                      this.findContactIdForRef(
                          this.avisFormInput.dossier?.avisPhoneNumberRef, false
                      ) ?? "",
                      this.avisFormInput.dossier?.avisPhoneNumberRef
                  );
                  this.avisPhoneNumberRef = this.avisFormInput.dossier?.avisPhoneNumberRef;
                }
                if (this.avisFormInput.dossier?.avisEmailRef) {
                  this.avisEmail = await contactApi.getEmailById(
                      this.findContactIdForRef(
                          this.avisFormInput.dossier?.avisEmailRef, true
                      ) ?? "",
                      this.avisFormInput.dossier?.avisEmailRef
                  );
                  this.avisEmailRef = this.avisFormInput.dossier?.avisEmailRef;
                }
                this.avisText = this.avisFormInput.dossier?.avisText ?? "";
            },
            immediate: true,
        },
    },
    methods: {
        resetData() {
            this.avisPhoneNumberRef = "",
            this.avisEmailRef = "",
            this.avisPhoneNumber = null ,
            this.avisEmail = null,
            this.newAvisPhoneNumberAddressContactRef = null,
            this.newAvisEmailAddressContactRef = null,
            this.avisText = null
        },
        async setAvisPhoneNumber() {
            if (this.avisPhoneNumberRef) {
                this.avisPhoneNumber = await contactApi.getPhoneNumberById(
                    this.findContactIdForRef(
                        this.avisPhoneNumberRef, false
                    ) ?? "",
                    this.avisPhoneNumberRef
                );
            }
            await this.updatePhoneNumber();
        },
        findContactIdForRef(ref: string, refIsEmail: boolean): string | null {
            if (this.avisFormInput.resellerContacts && this.avisFormInput.resellerContacts.length > 0) {
                let byReseller = null;
                this.avisFormInput.resellerContacts.forEach((reseller: ContactRelationResult) => {
                    const foundId = refIsEmail ? reseller.withContact.emailAddresses?.find(
                        (a) => a.id === ref
                    )?.id : reseller.withContact.phoneNumbers.find(
                        (a) => a.id === ref
                    )?.id;
                    if (foundId) {
                        byReseller = reseller.withContact.id;
                    }
                });
                if (byReseller) {
                    return byReseller;
                }
            }

            return this.avisFormInput.contact.id;
        },
        changedAvisPhonenumber(phonenumber: PhoneNumber) {
            this.avisPhoneNumber = phonenumber;
        },
        changedAvisEmail(email: EmailAddress) {
            this.avisEmail = email;
        },
        async savePhonenumber() {
            const res = await (findConfirmDialogRef(this) as any).open(
                this.$t("Achtung") as string,
                this.$t(
                    "AVIS-Rufnummer aktualisieren? Rufnummer wird im Kontakt ebenfalls aktualisiert"
                ) as string,
                {
                    textColor: "red",
                    noconfirm: false,
                }
            );
            if (res && this.avisFormInput.contact.id && this.avisPhoneNumber) {
                if (this.avisPhoneNumber.id) {
                    const updatedPhoneNumber = await contactApi.editPhonenumber(
                        this.findContactIdForRef(this.avisPhoneNumber.id, false) ?? "",
                        this.avisPhoneNumber.id,
                        this.avisPhoneNumber
                    );
                    this.avisPhoneNumber = {
                      ...updatedPhoneNumber
                    }
                } else if (this.newAvisPhoneNumberAddressContactRef) {
                    this.avisPhoneNumberRef = await contactApi.addNewPhonenumber(
                        this.newAvisPhoneNumberAddressContactRef,
                        this.avisPhoneNumber
                    );
                    this.avisPhoneNumber = {
                        ...this.avisPhoneNumber,
                        id: this.avisPhoneNumberRef,
                    };
                }
                await this.updatePhoneNumber();
            }
        },
        async saveEmail() {
            const res = await (findConfirmDialogRef(this) as any).open(
                this.$t("Achtung") as string,
                this.$t(
                    "AVIS-Email aktualisieren? E-Mail wird im Kontakt ebenfalls aktualisiert"
                ) as string,
                {
                    textColor: "red",
                    noconfirm: false,
                }
            );
            if (res && this.avisFormInput.contact.id && this.avisEmail) {
                if (this.avisEmail.id) {
                    const updatedEmail = await contactApi.editEmail(
                        this.findContactIdForRef(this.avisEmail.id, true) ?? "",
                        this.avisEmail.id,
                        this.avisEmail
                    );
                  this.avisEmail = {
                    ...updatedEmail,
                  }
                } else if (this.newAvisEmailAddressContactRef) {
                    this.avisEmailRef = await contactApi.addEmail(
                        this.newAvisEmailAddressContactRef,
                        this.avisEmail
                    );
                    this.avisEmail = {
                        ...this.avisEmail,
                        id: this.avisEmailRef,
                    };
                }
                await this.updateEmail();
            }
        },
        async addNewAvisPhonenumberFor(contact: Contact | ContactSearchRow) {
            this.avisPhoneNumberRef = "";
            this.avisPhoneNumber = {type: PhoneNumberType.MOBILE} as PhoneNumber;
            this.newAvisPhoneNumberAddressContactRef = contact.id;
        },
        async addNewAvisEmailFor(contact: Contact | ContactSearchRow) {
            this.avisEmailRef = "";
            this.avisEmail = {} as EmailAddress;
            this.newAvisEmailAddressContactRef = contact.id;
        },
        async updatePhoneNumber() {
            if (this.avisPhoneNumberRef) {
                this.$emit("phoneNumberChanged", this.avisPhoneNumberRef);
            } else if (this.avisFormInput.dossier?.avisPhoneNumberRef !== null) {
                this.avisPhoneNumber = null;
                this.$emit("phoneNumberChanged", null);
            }
            if (this.avisPhoneNumberRef === null) {
                this.avisPhoneNumber = null;
            }
        },
        async updateEmail() {
            if (this.avisEmailRef) {
                this.$emit("emailChanged", this.avisEmailRef);
            } else if (this.avisFormInput.dossier?.avisEmailRef !== null) {
                this.$emit("emailChanged", null);
            }
        },
        async updateAvisText() {
            this.$emit("avisTextChanged", this.avisText);
        },
    },
});
